var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pills_2 (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 9.20833C7.62266 9.20833 9.20833 7.62266 9.20833 5.66667C9.20833 3.71068 7.62266 2.125 5.66667 2.125C3.71068 2.125 2.125 3.71068 2.125 5.66667C2.125 7.62266 3.71068 9.20833 5.66667 9.20833ZM7.19089 5.42169C7.37173 5.34714 7.4579 5.14013 7.38338 4.95929C7.30887 4.77842 7.10182 4.69225 6.92098 4.76676L4.14247 5.91182C3.96164 5.98634 3.87543 6.19338 3.94999 6.37422C4.0245 6.55506 4.23151 6.64126 4.41239 6.56671L7.19089 5.42169Z",
    fill: "#5571C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 14.875C13.2894 14.875 14.8751 13.2893 14.8751 11.3333C14.8751 9.3773 13.2894 7.79163 11.3334 7.79163C9.37742 7.79163 7.79175 9.3773 7.79175 11.3333C7.79175 13.2893 9.37742 14.875 11.3334 14.875ZM12.7185 12.0151C12.9091 12.0589 13.0991 11.9399 13.143 11.7493C13.1868 11.5587 13.0678 11.3686 12.8772 11.3248L9.94838 10.6515C9.75773 10.6076 9.56768 10.7266 9.52384 10.9173C9.48003 11.1079 9.59902 11.298 9.78967 11.3418L12.7185 12.0151Z",
    fill: "#5571C6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.97912182d5c3f15f9c6931021814f95a.svg";
export { ForwardRef as ReactComponent };